import React from 'react';
import styled from '@emotion/styled';
import { List } from 'antd';
import { EventCard } from 'app/components/Card/Event';
import { IInspection } from 'app/types/interfaces/Inspection';
import { STATUS_TYPE } from 'app/components/Status/JobStatus';

const StyledListItem = styled(List.Item)`
  padding-top: 0;
  .ant-card-bordered {
    margin-top: 0;
    width: 100%;
  }
`;

type Props = {
  period: Array<string>;
  inspection: IInspection;
  inspectorName: string;
  status: STATUS_TYPE;
  phone: string | null | undefined;
  onClick: (e: any) => void;
};
const ListEventItem = (props: Props) => {
  const { period, inspection, status, inspectorName, phone, onClick } = props;
  const labels = React.useMemo(() => {
    return (
      [
        inspection?.factory?.area?.city,
        inspection?.factory?.area?.state,
        inspection?.factory?.area?.country
      ]
        .filter((v) => !!v)
        .join(', ') || 'N/A'
    );
  }, [inspection]);

  const info = React.useMemo(() => {
    return [`${inspectorName}`, phone];
  }, [inspectorName, phone]);
  return (
    <StyledListItem onClick={onClick}>
      <EventCard
        state={labels || ''}
        description={inspection?.factory?.address}
        subtitle={inspection?.factory?.name}
        title={period.join(' - ')}
        status={status}
        image=""
        info={info.filter((value) => !!value).join(', ')}
      ></EventCard>
    </StyledListItem>
  );
};

export default ListEventItem;
